import { render, staticRenderFns } from "./InwardEditRequestItem.vue?vue&type=template&id=218daaaa&scoped=true&"
import script from "./InwardEditRequestItem.vue?vue&type=script&lang=ts&"
export * from "./InwardEditRequestItem.vue?vue&type=script&lang=ts&"
import style0 from "./InwardEditRequestItem.vue?vue&type=style&index=0&id=218daaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218daaaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
